import { CHARTS_FOR_EXPORT } from 'constants/actionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHARTS_FOR_EXPORT:
      return action.chartsObject || initialState;
    default:
      return state;
  }
};
